import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import FlagIcon from 'material-ui/svg-icons/content/flag';
import EditIcon from 'material-ui/svg-icons/image/edit';
import { formatCurrency, addLeftZeros } from 'shared/helpers/dataFormatHelper';
import { textColorGray } from 'theme/mainColors';
import LinearProgress from "material-ui/LinearProgress";

const InvoiceHeaderDetail = props => (
  <div className="header-detail">
    {
      props.invoice &&
          <div className={ `generic-grid__main-container${ props.fetchingInvoice ? ' blur-content' : '' }` }>
            {
              props.fetchingInvoice && <LinearProgress mode="indeterminate"/>
            }
            <div className="title">
              {
                props.isInvoiceLine !== undefined &&
                <span style={ { color: textColorGray } }>
                  {
                    props.isInvoiceLine
                      ? "Line" + ' ' + addLeftZeros(props.invoice.number)
                      : props.invoice.invoice
                        ? <div className="invoice-value">
                          <span style={ { marginRight: 6 } }>Invoice</span>
                          <span >{ props.invoice.invoice }</span>
                        </div>
                        : "Invoice"
                  }
                </span>
              }
              
              <IconButton 
                onClick={ () => props.onEditClick() }
                disabled={ props.fetchingInvoice ||
                  props.invoiceDetail &&
                  props.invoiceDetail.allocationJurisdictions &&
                  props.invoiceDetail.allocationJurisdictions.length > 0 }
              >
                <EditIcon color="#777"/>
              </IconButton>
              <div className="header-detail-right-title-buttons">
                <IconButton style={ { display: props.isInvoiceLine ? '' : 'none' } }><FlagIcon color="#777"/></IconButton>
                <IconButton style={ { display: props.isInvoiceLine ? '' : 'none' } }><DeleteIcon color="#777"/></IconButton>
                <IconButton onClick={ () => props.closeSlidingPanel() }><ClearIcon color="#777"/></IconButton>
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <div className="vendor">
                  <ul>
                    <li>
                      <div className="field">Gross</div>
                      <div className="value">
                        <span>{props.invoice.grossAmount ? formatCurrency(props.invoice.grossAmount) : "-"}</span></div>
                    </li>
                    <li>
                      <div className="field">Date</div>
                      <div className="value"><span>{props.isInvoiceLine ? props.invoiceDateAndVendor.date : props.invoice.date}</span>
                      </div>
                    </li>
                    <li style={ { display: props.isInvoiceLine ? '' : 'none' } }>
                      <div className="field">Status</div>
                      <div className="value"><span>{props.invoice.lineStatus}</span></div>
                    </li>
                    <li>
                      <div className="field">Vendor</div>
                      <div className="value">
                        <span>{props.isInvoiceLine ? props.invoiceDateAndVendor.vendorName : props.invoice.vendorName}</span></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="column">
                <div className="taxes">
                  <ul>
                    <li>
                      <div className="field">Vendor Tax</div>
                      <div><span>{props.invoice.vendorTax ? formatCurrency(props.invoice.vendorTax) : "-"}</span></div>
                    </li>
                    <li>
                      <div className="field">Sovos Tax</div>
                      <div><span>{props.invoice.calculatedTax ? formatCurrency(props.invoice.calculatedTax) : "-"}</span></div>
                    </li>
                    <li>
                      <div className="field">Variance</div>
                      <div style={ {display: 'flex', flexWrap: 'wrap', width: '200px'} }>
                        <div style={ {margin: '0 0 5px 0'} }><span style={ {
                          color: '#ff0000',
                          margin: '0 20px 0 0'
                        } }>{props.invoice.dollarVariance ? formatCurrency(props.invoice.dollarVariance) : "-"}</span></div>
                        <div><span style={ {color: 'red'} }>{props.invoice.percentVariance}%</span></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="column" style={ {border: "none"} }>
                <div className="goodServiceCode">
                  <ul>
                    <li style={ {display: props.isInvoiceLine ? '' : 'none'} }>
                      <div className="field">Goods / Service Code</div>
                      <div><span>{props.invoice.goodServiceCode ? props.invoice.goodServiceCode : "-"}</span></div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    }
  </div>
);

InvoiceHeaderDetail.propTypes = {
  invoice: PropTypes.object,
  invoiceDateAndVendor: PropTypes.object,
  isInvoiceLine: PropTypes.bool,
  invoiceDetail: PropTypes.object,
  fetchingInvoice: PropTypes.bool,
  closeSlidingPanel: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired
};

InvoiceHeaderDetail.defaultProps = {
  isInvoiceLine: true
};

export default InvoiceHeaderDetail;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/InvoiceHeaderDetail.js